/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import PricingBanner from "./PricingBanner";

const PricingBannerContainer = () => {
  return (
    <PricingBanner />
  );
};

export default PricingBannerContainer;
